import React from "react";
import { Box, Cluster, Paragraph } from "@thecb/components";

import CloseIcon from "../CloseIcon";
import ErrorIcon from "../ErrorMessage/ErrorIcon";
import SuccessIcon from "../SuccessMessage/SuccessIcon";
import { BACKGROUND_LIGHT_GREEN, ERROR_SECONDARY, WHITE } from "@/constants/colors";
import { SEMI_BOLD } from "@/constants/fonts";
import { CloseIconWrapper } from "./ToastNotification.styled";

const ToastNotification = ({
  content = "",
  extraStyles,
  minWidth = "112px",
  maxWidth = "350px",
  height = "56px",
  closeToastNotification,
  toastOpen,
  variant = "success",
  backgroundColor,
}) => (
  <Box
    onClick={closeToastNotification}
    background={
      backgroundColor
        ? backgroundColor
        : variant == "success"
        ? BACKGROUND_LIGHT_GREEN
        : variant == "error"
        ? ERROR_SECONDARY
        : WHITE
    }
    minWidth={minWidth}
    minHeight={height && parseInt(height) < 100 ? height : "100px"}
    height={height ? height : "auto"}
    tabIndex={toastOpen ? "-1" : "0"}
    padding="0"
    borderRadius="4px"
    boxShadow="0px 4px 4px rgba(41, 42, 51, 0.15),
      0px 1px 7px rgba(41, 42, 51, 0.2),
      0px 7px 12px rgba(41, 42, 51, 0.15)"
    extraStyles={`
      display: ${toastOpen ? "block" : "none"};
      position: fixed; bottom: 4rem; left: 4rem;
      ${extraStyles};
    `}
  >
    <Cluster align="center" childGap="0">
      {variant === "success" && <SuccessIcon />}
      {variant === "error" && <ErrorIcon />}
      <Box padding="1rem 0" maxWidth={maxWidth}>
        <Paragraph weight={SEMI_BOLD} extraStyles={"word-break: break-word;"}>
          {content}
        </Paragraph>
      </Box>
      <CloseIconWrapper>
        <CloseIcon />
      </CloseIconWrapper>
    </Cluster>
  </Box>
);

export default ToastNotification;
